const videoDataNormalizer = (componentData, normalizerConfig) => {
  const shouldNormalizeDisableDownload = componentData.disableDownload === void 0 && normalizerConfig.disableDownload;
  if (shouldNormalizeDisableDownload) {
    componentData.disableDownload = true;
  }
  return componentData;
};

export { videoDataNormalizer as default };
//# sourceMappingURL=videoDataNormalizer.js.map
